import { Switch, message } from 'antd';
import React, { useEffect, useState } from 'react';
import IngredientsService from '../../../../services/IngredientsService';

const Availability = (props) => {
    const [ingredientList, setIngredientList ] = useState([]);

    const getAllIngredients = () => {
        IngredientsService.getIngredients(props.adminRestaurant).then((res)=>{
            setIngredientList(res);
        });
    };
      useEffect(()=>{
        getAllIngredients();
      }, []);

    const onUpdateSettings = (e, key, item) => {
        const curentSettings = [...ingredientList];
        curentSettings[key].is_available = e;
        setIngredientList(curentSettings);
        IngredientsService.updateIngredients(item.id, { is_available: e }).then((resp)=>{
            getAllIngredients();
            message.success("Successfully updated");
        })
    };

    return <div className="table_section field_wrap">
        <div className='field_ctrllist'>
        {
            ingredientList.map((item, key)=>{
                return <div className="ctrl_field">
                <span><Switch checked={item.is_available} onChange={(e)=>{onUpdateSettings(e, key, item)}}/></span>
                <label>{item.name}</label>
            </div>
            })
        }
        </div>
    </div>
};
export default Availability;
